module.exports = __webpack_public_path__ + "static/media/step-2-en.039ac52e.jpg";